import { render, staticRenderFns } from "./SupportTemplates.vue?vue&type=template&id=074f0999&scoped=true"
import script from "./SupportTemplates.vue?vue&type=script&lang=js"
export * from "./SupportTemplates.vue?vue&type=script&lang=js"
import style0 from "./SupportTemplates.vue?vue&type=style&index=0&id=074f0999&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074f0999",
  null
  
)

export default component.exports